import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const getAdminDashbaordData = (id) => {
  return Api(`${endPoints.getAdminDashboardData}/${id}`, null, requestType.GET);
};

const getAdminReportData = ( id ,query) => {
  return Api(
    `${endPoints.getAdminReportData}/${id}?startDate=${query.startDate}&endDate=${query.endDate}`,
    null,
    requestType.GET
  );
};

export { getAdminDashbaordData, getAdminReportData };
